
export enum E_ShareType {
    SEEK_SEARCH = 'SEEK_SEARCH',
    TECH_MIND = 'TECH_MIND',
    TECH_RESEARCH = 'TECH_RESEARCH',
    NEWS_LETTER = 'NEWS_LETTER'
}

export const SHARE_TYPE_MAP = {
    air: E_ShareType.SEEK_SEARCH,
    whiteboard: E_ShareType.TECH_MIND,
    project: E_ShareType.TECH_RESEARCH,
    newsletter: E_ShareType.NEWS_LETTER,
}

export interface ShareAuthRequiredData {
    id: string;
    type: E_ShareType;
}
